import { z } from 'zod';
import { paginatedQuerySchema } from '~/util/types/api';
export const mergeRequestsParamsSchema = z
    .object({
        status: z
            .enum(['Pending', 'Claimed', 'Denied'])
            .nullable()
            .default(null),
    })
    .extend(paginatedQuerySchema().shape);

export type mergeRequestsParamsType = z.infer<typeof mergeRequestsParamsSchema>;

export const defaultMergeRequestsParams = mergeRequestsParamsSchema.parse({});
